import { infiniteQueryOptions, useInfiniteQuery } from "@tanstack/react-query";
import api from "~/shared/api/core/api";
import { Params } from "~/shared/api/types/params";
import { createInfinitePaginationConfig } from "~/shared/util/createInfinitePaginationConfig";

const FUNCTIONAL_AREAS_KEYS = {
  all: ["functional-areas"] as const,
  list: (params: Params) => [...FUNCTIONAL_AREAS_KEYS.all, "list", params] as const,
};

export const FUNCTIONAL_AREAS_QUERIES = {
  list: (params: { [key: string]: unknown }) => {
    const paginationConfig = createInfinitePaginationConfig(params, 20);

    return infiniteQueryOptions({
      queryFn: async ({ pageParam = 1, signal }) => {
        const response = await api.get(`/functional-areas`, {
          params: paginationConfig.queryFnParams(pageParam),
          signal,
        });

        return response.data;
      },
      queryKey: FUNCTIONAL_AREAS_KEYS.list({
        params: paginationConfig.keyParams,
      }),
      ...paginationConfig.opts,
    });
  },
};

export function useInfiniteFunctionalAreasFilter(params: { [key: string]: unknown }) {
  return useInfiniteQuery(FUNCTIONAL_AREAS_QUERIES.list(params));
}
